<template>
    <div>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-tu-page-heading">
                    <h3 class="fw-bold">{{ TipoUsuario.tusId ? 'Alterar tipo de usuário' : 'Novo tipo de usuário' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Tipos de usuário</a></li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ TipoUsuario.tusId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-tu-form-header"><span><v-icon size="20">mdi-account-key-outline</v-icon></span><div><h4>{{ TipoUsuario.tusId ? 'Alterar tipo de usuário' : 'Novo tipo de usuário' }}</h4><p>Defina o perfil, sua disponibilidade e vínculo.</p></div></div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="TipoUsuario.tusId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4">
                                        <div class="form-group">
                                            <label>Nome</label>
                                            <input v-model="TipoUsuario.tusNome"
                                                type="text" class="form-control" placeholder="Nome" />
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Visivel</label>
                                            <select v-model="TipoUsuario.tusVisivel" class="form-select form-control"
                                                id="defaultSelect">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-2 col-lg-2">
                                        <div class="form-group">
                                            <label>Ativo</label>
                                            <select v-model="TipoUsuario.tusAtivo" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="TipoPessoas != ''">
                                        <div class="form-group">
                                            <label>Tipo</label>
                                            <select  v-model="TipoUsuario.tpeId" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option v-for="optionTipo in TipoPessoas" :key="optionTipo.tpeId"
                                                    :value="optionTipo.tpeId">{{ optionTipo.tpeNome }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-4 col-lg-4" v-if="TipoUsuario.tpeId == 1">
                                        <div class="form-group">
                                            <label>Garantidoras</label>
                                            <select class="form-select form-control" id="defaultSelect">
                                                <option value="">Selecione</option>
                                            </select>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-tu-actions gp-detail-actions">
                        <button v-if="TipoUsuario.tusId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            <v-icon size="16">mdi-content-save-outline</v-icon> Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            <v-icon size="16">mdi-content-save-outline</v-icon> Salvar
                        </button>
                        <a href="#" @click.prevent="EditCancel()" class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de tipos de usuário</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body" v-if="TipoPessoas!=''">
                                <div class="gp-tu-filters"><div><label>Pesquisa</label><input v-model.trim="searchValue" type="text" class="form-control" placeholder="Pesquisar por id, nome, tipo ou situação" /></div><button type="button" class="btn btn-outline-secondary" :disabled="!searchValue" @click="searchValue = ''"><i class="fas fa-eraser"></i> Limpar</button></div>
                                <div class="gp-tu-toolbar"><span>{{ tiposFiltrados.length }} registro(s) encontrado(s)</span><button type="button" class="btn gp-export-button" :disabled="!tiposFiltrados.length" @click="exportarExcel"><v-icon size="16">mdi-microsoft-excel</v-icon> Exportar Excel</button></div>
                                <garante-pay-data-table :headers="headers" :items="tiposFiltrados" v-model="itemsSelected" alternating
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina">
                                    <template #item-tusVisivel="item">
                                        <span class="gp-tu-status" :class="item.tusVisivel ? 'is-active' : 'is-neutral'">{{ item.tusVisivel ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-tusAtivo="item">
                                        <span class="gp-tu-status" :class="item.tusAtivo ? 'is-active' : 'is-inactive'">{{ item.tusAtivo ? 'Ativo' : 'Inativo' }}</span>
                                    </template>
                                    <template #item-tpeId="item">
                                        <span>{{ nomeTipoPessoa(item.tpeId) }}</span>
                                    </template>
                                    <template #item-actions="item">
                                        <div class="gp-table-actions"><button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button><button type="button" class="gp-table-action gp-action-delete" title="Excluir" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button></div>
                                    </template>
                                </garante-pay-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
export default {
    name: 'CadastroTipoUsuarioView',
    components: {},
    data: () => ({
        EditView: false,
        TipoUsuario: {
            tusId: 0,
            tusNome: '',
            tusVisivel: '',
            tusAtivo: '',
            tpeId: '',
        },
        TipoUsuarios: [],
        selectedVisivel: null,
        headers: [
            { text: "Id", value: "tusId", sortable: true, },
            { text: "Nome", value: "tusNome", sortable: true, },
            { text: "Visivel", value: "tusVisivel", sortable: true, },
            { text: "Ativo", value: "tusAtivo", sortable: true, },
            { text: "Tipo", value: "tpeId", sortable: true, },
            { text: 'Ações', value: 'actions' }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
        TipoPessoas:[],
    }),
    computed: {
        tiposFiltrados() {
            const termo = this.normalizar(this.searchValue);
            if (!termo) return this.TipoUsuarios;
            return this.TipoUsuarios.filter(item => [item.tusId, item.tusNome, this.nomeTipoPessoa(item.tpeId), item.tusVisivel ? 'visivel sim' : 'invisivel nao', item.tusAtivo ? 'ativo' : 'inativo'].some(value => this.normalizar(value).includes(termo)));
        }
    },
    methods: {
        normalizar(value) { return String(value ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase(); },
        nomeTipoPessoa(tpeId) { return tpeId == null ? 'GarantePay' : this.TipoPessoas.find(item => item.tpeId == tpeId)?.tpeNome || '—'; },
        async exportarExcel() {
            if (!this.tiposFiltrados.length) return;
            const XLSX = await import('xlsx');
            const dados = this.tiposFiltrados.map(item => ({ Id: item.tusId, Nome: item.tusNome, Tipo: this.nomeTipoPessoa(item.tpeId), Visível: item.tusVisivel ? 'Sim' : 'Não', Situação: item.tusAtivo ? 'Ativo' : 'Inativo' }));
            const planilha = XLSX.utils.json_to_sheet(dados), arquivo = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(arquivo, planilha, 'Tipos de usuário');
            XLSX.writeFile(arquivo, `tipos-usuario-filtrados-${this.$moment().format('YYYY-MM-DD-HHmm')}.xlsx`);
        },
          //edit
          EditNew(){
            this.EditView = true;
            this.TipoUsuario.tusId = 0;
            this.TipoUsuario.tusNome= '';
            this.TipoUsuario.tusVisivel= '';
            this.TipoUsuario.tusAtivo= '';
            this.TipoUsuario.tpeId= '';
        },
        EditGrid(item) {
            this.EditView = true;
            if (item.tusId != ''){
            axios.get(`/Telas/TipoUsuario/GetById/` + item.tusId)
                .then(response => {
                    this.TipoUsuario = response.data;
                });
            }
        },
        Add() {
            if (this.TipoUsuario.tusNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.TipoUsuario.tusVisivel === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.TipoUsuario.tusAtivo === '') {
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                if (this.TipoUsuario.tpeId === "") {
                        this.TipoUsuario.tpeId = null;
                    }
                    
                axios.post(`/Telas/TipoUsuario/Add`, this.TipoUsuario)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                        }
                    });
            }
        },
        Put() {
            if (this.TipoUsuario.tusNome == '') {
                this.$mensagemAviso("Nome Obrigatório.")
            }
            else if (this.TipoUsuario.tusVisivel === '') {
                this.$mensagemAviso("Visível Obrigatório.")
            }
            else if (this.TipoUsuario.tusAtivo === '') {
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                if (this.TipoUsuario.tpeId === "") {
                        this.TipoUsuario.tpeId = null;
                    }


                axios.put(`/Telas/TipoUsuario/Update`, this.TipoUsuario)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
            }
        },
        EditCancel(){
            this.EditView = false;
        },
          //edit
        DeleteGrid(item) {

            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
            if (result.isConfirmed) {
                // Lógica para excluir o item
                const param1 = item.tusId;
                axios.delete(`/Telas/TipoUsuario/Delete/${param1}`)
                .then(response => {
                    if (response.status == 200) {
                        this.$mensagemAvisoSucesso("Registro Excluido.")
                        this.Get();
                    }
                });
            }
            });
        },
        async Get() {
            this.EditView = false;
            await axios.get(`/Telas/TipoUsuario/GetDados`)
               .then(response => {
                this.TipoUsuarios = response.data.tipoUsuarios;
                 this.TipoPessoas = response.data.tiposPessoas;
           });
            
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style scoped>
.gp-tu-page-heading{align-items:center;gap:12px;margin-bottom:20px}.gp-tu-page-heading h3{margin:0;color:#102a5a;font-size:14px}.gp-tu-page-heading .breadcrumbs{margin:0}.gp-tu-form-header{display:flex;align-items:center;gap:11px;padding:13px 16px;border-bottom:1px solid #e8e1d7;background:#fcf8f2}.gp-tu-form-header>span{width:34px;height:34px;display:grid;place-items:center;border-radius:10px;background:#fff0dd;color:#bd6300}.gp-tu-form-header h4{margin:0;color:#102a5a;font-size:13px;font-weight:800}.gp-tu-form-header p{margin:2px 0 0;color:#68748a;font-size:10.5px}.gp-tu-actions{display:flex;justify-content:flex-end;gap:8px}.gp-tu-actions .btn{min-width:118px;display:inline-flex;align-items:center;justify-content:center;gap:5px}.gp-tu-actions .btn-link{min-width:auto}
.gp-tu-filters{display:grid;grid-template-columns:minmax(0,1fr) 160px;align-items:end;gap:12px;margin-bottom:10px;padding:14px;border:1px solid #e1d9cd;border-left:4px solid #e77900;border-radius:12px;background:#fcf8f2}.gp-tu-filters label{display:block;margin-bottom:5px;color:#4d586d;font-size:11px;font-weight:750}.gp-tu-filters .form-control,.gp-tu-filters .btn{min-height:38px;border-radius:9px;font-size:12px}.gp-tu-toolbar{display:flex;align-items:center;justify-content:space-between;gap:12px;margin:0 2px 10px;color:#68748a;font-size:11.5px;font-weight:650}.gp-export-button{display:inline-flex;align-items:center;gap:6px;border:1px solid #a9d6bf!important;background:#e7f7ef!important;color:#16724b!important}.gp-tu-status{display:inline-flex;justify-content:center;min-width:58px;padding:3px 8px;border-radius:999px;font-size:9.5px;font-weight:750}.gp-tu-status.is-active{background:#e7f7ef;color:#16724b}.gp-tu-status.is-neutral{background:#edf0f4;color:#667085}.gp-tu-status.is-inactive{background:#fdebed;color:#b52b3b}
@media(max-width:767.98px){.gp-tu-page-heading{align-items:flex-start;flex-direction:column}.gp-tu-filters{grid-template-columns:1fr}.gp-tu-toolbar,.gp-tu-actions{align-items:stretch;flex-direction:column}.gp-tu-toolbar .btn,.gp-tu-actions .btn{width:100%}}
</style>
